import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';

/**
 * 运费模板适用站点列表（同步时按站命中累加）。
 */
export default function FreightTemplateSitesModal({
  open = false,
  templateName = '',
  templateId = '',
  regionLabel = '',
  sites = [],
  onClose,
}) {
  const { t } = useTranslation('workbench');
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const rows = Array.isArray(sites) ? sites : [];
  const title = templateName || templateId || t('freightLib.library');

  return createPortal(
    <div className="tpo-freight-sites-modal" role="presentation" onClick={onClose}>
      <div
        className="tpo-freight-sites-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tpo-freight-sites-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="tpo-freight-sites-modal__head">
          <div>
            <h2 id="tpo-freight-sites-title">{t('freightLib.sitesTitle')}</h2>
            <p className="tpo-freight-sites-modal__sub">
              {title}
              {regionLabel ? ` · ${regionLabel}` : ''}
              {rows.length ? ` · ${t('freightLib.siteCount', { count: rows.length })}` : ''}
            </p>
          </div>
          <button type="button" className="tpo-freight-sites-modal__close" onClick={onClose} aria-label={t('moduleShell.close')}>
            ×
          </button>
        </header>
        <div className="tpo-freight-sites-modal__body">
          {rows.length === 0 ? (
            <p className="tpo-freight-sites-modal__empty">
              {t('freightLib.sitesEmpty')}
            </p>
          ) : (
            <ul className="tpo-freight-sites-modal__list">
              {rows.map((site) => {
                const id = site?.siteId ?? site?.id;
                const name = site?.siteName || site?.name || (id != null ? t('freightLib.siteFallback', { id }) : '—');
                return (
                  <li key={String(id)} className="tpo-freight-sites-modal__item">
                    <span className="tpo-freight-sites-modal__name">{name}</span>
                    <span className="tpo-freight-sites-modal__id">{id != null ? `ID ${id}` : ''}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        <footer className="tpo-freight-sites-modal__foot">
          <button type="button" className="tpo-btn tpo-btn--primary" onClick={onClose}>
            {t('freightLib.done')}
          </button>
        </footer>
      </div>
    </div>,
    document.body
  );
}
